<template>
  <div id="app" class="h-full" :style="{ '--txt': textcolor }">
    <navigation />
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
const Navigation = () =>
  import(/* webpackChunkName: "Navigation" */ "@/components/Navigation.vue");
export default {
  name: "App",
  metaInfo() {
    return {
      titleTemplate: "Omnigroup" + " %s",
    };
  },
  components: {
    Navigation,
  },
  data() {
    return {
      textcolor: "#000",
    };
  },
  mounted() {
    this.$root.$on("colorChange", this.changeColor);
  },
  computed: mapState(["site"]),
  created() {
    this.$store.dispatch("loadSite");
    this.$store.dispatch("loadProjects", 0);
    this.$store.dispatch("loadAbout");
  },
  methods: {
    changeColor(color) {
      this.textcolor = color;
    },
  },
};
</script>
